import React, { type CSSProperties, type ReactElement, type ReactNode, useMemo } from 'react';
import { useContainerWidth } from './helpers.js';
import { type IMasonry } from './Masonry.js';

const DEFAULT_COLUMNS_COUNT = 1;

interface IResponsiveMemory {
  children: ReactNode;

  columnsCountBreakPoints?: {
    [key: number]: number;
  };

  className?: string;

  style?: CSSProperties;
}
export const ResponsiveMasonry = ({
  children,
  columnsCountBreakPoints = { 350: 1, 750: 2, 900: 3 },
  className,
  style,
}: IResponsiveMemory) => {
  const [containerRef, containerWidth] = useContainerWidth<HTMLDivElement>();

  const columnsCount = useMemo(() => {
    const breakPoints = Object.keys(columnsCountBreakPoints)
      .sort((a, b) => {
        return parseInt(a) - parseInt(b);
      })
      .map((bp) => parseInt(bp));
    let count = breakPoints.length > 0 ? columnsCountBreakPoints[breakPoints[0]] : DEFAULT_COLUMNS_COUNT;

    breakPoints.forEach((breakPoint) => {
      if (breakPoint < containerWidth) {
        count = columnsCountBreakPoints[breakPoint];
      }
    });

    return count;
  }, [containerWidth, columnsCountBreakPoints]);

  return (
    <div ref={containerRef} className={className} style={style}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child as ReactElement<IMasonry>, {
          key: index,
          columnsCount: columnsCount,
        })
      )}
    </div>
  );
};
